// React Imports
import * as React from "react";
import {useState} from "react";
import {useDispatch, useSelector} from "react-redux";


// Mui Imports
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import {Avatar, ListItemIcon, ListItemText, Tooltip} from "@mui/material";
import Divider from "@mui/material/Divider";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import AutoAwesomeMotionIcon from "@mui/icons-material/AutoAwesomeMotion";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import DoneOutlineIcon from '@mui/icons-material/DoneOutline';
import PreviewIcon from "@mui/icons-material/Preview";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import ClearAllIcon from "@mui/icons-material/ClearAll";
import DriveFileMoveIcon from "@mui/icons-material/DriveFileMove";
import PersonIcon from "@mui/icons-material/Person";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import CalculateIcon from "@mui/icons-material/Calculate";
import Badge from "@mui/material/Badge";
import ViewModuleIcon from "@mui/icons-material/ViewModule";

// App Imports
import DeleteContract from "./ContractActions/DeleteContract";
import AddContract from "./ContractActions/AddContract";
import BulkEditContract from "./ContractActions/BulkEditContract";
import CardViewContract from "./ContractActions/CardViewContract";
import CalcContract from "./ContractActions/CalcContract";
import CopyContract from "./ContractActions/CopyContract";
import CloneContract from "./ContractActions/CloneContract";
import MoveContract from "./ContractActions/MoveContract";
import RandomizeContract from "./ContractActions/RandomizeContract";
import PopulateContract from "./ContractActions/PopulateContract";
import ReplaceContract from "./ContractActions/ReplaceContract";
import GuildMultiSelect from "../../Menus/GuildMultiSelect";
import ProductGuildDialogue from "../../ExternalData/Product/ProductGuildDialogue";
import {changeWorkQueue} from "../workQueueSlice";
import TestContract from "./ContractActions/TestContract";


// main function
export default function ContractActionMenu({ rowContractData }) {



    // ****************** BEGIN STATES ****************************

    const [anchorEl, setAnchorEl] = React.useState(null);

    // ****************** END STATES ****************************


    // *********************** BEGIN STORE ********************************

    const menuContractId = useSelector((state) => state.workQueueSlc.value.actionMenuContractId);
    const menuContractName = useSelector((state) => state.workQueueSlc.value.actionMenuName);
    const menuContractLevel = useSelector((state) => state.workQueueSlc.value.actionMenuContractLevel);
    const menuProductId = useSelector((state) => state.workQueueSlc.value.actionMenuProductId);
    const menuFailedExpressionCount = useSelector((state) => state.workQueueSlc.value.actionMenuFailedExpressionCount);
    const menuFailedFilterCount = useSelector((state) => state.workQueueSlc.value.actionMenuFailedFilterCount);
    const menuInputMissingCount = useSelector((state) => state.workQueueSlc.value.actionMenuInputMissingCount);
    // const isMenuOpen = useSelector((state) => state.workQueueSlc.value.actionMenuState);
    const selectorProductGuildDialogueState = useSelector((state) => state.workQueueSlc.value.productGuildDialogueState);

    // ********************** END STORE ********************************

    // ****************** BEGIN DISPATCH ****************************

    const dispatchData = useDispatch() ;

    // ****************** END DISPATCH ****************************



    const isMenuOpen = Boolean(anchorEl);



    // ***************** BEGIN CONTROLS ***************************

    const handleCrudMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
        console.log("this is the contract selected by the menu click: ", menuContractId);
        console.log("menuContractName: ", menuContractName);
        console.log("menuContractLevel: ", menuContractLevel);
        console.log("menuProductId: ", menuProductId);
        console.log("menuFailedExpressionCount: ", menuFailedExpressionCount);
        console.log("menuFailedFilterCount: ", menuFailedFilterCount);
        console.log("menuInputMissingCount: ", menuInputMissingCount);
        // dispatchData(changeWorkQueue({actionMenuState: true}));
    };


    function handleMenuClose() {
        setAnchorEl(null);
        // dispatchData(changeWorkQueue({actionMenuState: false}));
    };


    // *************** END CONTROLS *******************************


// ***************** BEGIN MENU ***************************

    const crudId = 'primary-search-account-menu';

    const renderMenu = (

        <Menu
            anchorEl={anchorEl}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            id={crudId}
            keepMounted
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            open={isMenuOpen}
            onClose={handleMenuClose}
        >
            <MenuItem sx={{justifyContent: 'center', cursor: 'default'}}>
                <ListItemText primary="Actions" sx={{textAlign: 'center'}}/>
            </MenuItem>
            <Divider/>


            < AddContract onMenuClose={handleMenuClose}  rowContractData={rowContractData} />

            < BulkEditContract onMenuClose={handleMenuClose}  rowContractData={rowContractData} />

            < CardViewContract onMenuClose={handleMenuClose}  rowContractData={rowContractData} />

            < DeleteContract onMenuClose={handleMenuClose}  rowContractData={rowContractData} />

            < TestContract onMenuClose={handleMenuClose}  rowContractData={rowContractData} />

            < CalcContract onMenuClose={handleMenuClose}  rowContractData={rowContractData} />

            < CopyContract onMenuClose={handleMenuClose}  rowContractData={rowContractData} />

            < CloneContract onMenuClose={handleMenuClose}  rowContractData={rowContractData} />

            < MoveContract onMenuClose={handleMenuClose}  rowContractData={rowContractData} />

            < PopulateContract onMenuClose={handleMenuClose}  rowContractData={rowContractData} />

            < RandomizeContract onMenuClose={handleMenuClose}  rowContractData={rowContractData} />

            < ReplaceContract onMenuClose={handleMenuClose}  rowContractData={rowContractData} />


        </Menu>
    );

// ***************** END MENU ***************************


    // ****************** BEGIN RETURN ****************************

    return (
        <div>
            <IconButton
                size="large"
                edge="end"
                aria-label="account of current user"
                aria-controls={crudId}
                aria-haspopup="true"
                onClick= {handleCrudMenuOpen}

                color="inherit"
            >
                <Badge variant="dot">
                    <MoreVertIcon
                        color="action"
                        fontSize="small"/>
                </Badge>
            </IconButton>

            {renderMenu}



        </div>
    );

    // ****************** END RETURN ****************************

}
